import React from 'react'
import { Helmet } from 'react-helmet'
import Expertices from './Expertices'
import People from './People'

const ExpertiseMain = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Unlock your business potential with Umang Ratani Consultancy. We offer tailored strategies to drive growth, boost efficiency, and achieve your business goals.' />
                <title>Umang Ratani: Empowering Business Success</title>
            </Helmet>
            <Expertices/>
            <People/>
        </>
    )
}

export default ExpertiseMain
